import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog";
import { DialogTitle } from "@radix-ui/react-dialog";
import { Loader2 } from "lucide-react";

export function ConfirmationDialog({
    open,
    onOpenChange,
    onConfirm,
    isPending = false,
    heading = "Confirm Action",
    message,
    confirmLabel = "Confirm",
    // cancelLabel = "Cancel",
}: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    isPending?: boolean;
    heading?: string;
    message: string;
    confirmLabel?: string;
    // cancelLabel?: string;
}) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{heading}</DialogTitle>
                </DialogHeader>

                <div className="space-y-4">
                    <p className="text-gray-600">{message}</p>

                    <div className="flex justify-end space-x-2">
                        {/* <Button
                            type="button"
                            variant="outline"
                            onClick={() => onOpenChange(false)}
                            disabled={isPending}
                        >
                            {cancelLabel}
                        </Button> */}

                        <Button
                            type="button"
                            variant="default"
                            disabled={isPending}
                            onClick={onConfirm}
                        >
                            {isPending ? (
                                <>
                                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                    Processing...
                                </>
                            ) : (
                                confirmLabel
                            )}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
